exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message-banner[data-v-1ecd88f5]{padding:10px;border-radius:5px}.warning[data-v-1ecd88f5]{background:#e0a800;color:#fff}.error[data-v-1ecd88f5]{background:#bb555b;color:#fff}.success[data-v-1ecd88f5]{background:#229e4d;color:#fff}.info[data-v-1ecd88f5]{background:#4278b1;color:#fff}", ""]);

// exports
